// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import SoftInput from 'components/SoftInput'
import { IconButton, Tooltip, Fade } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import { useFieldState } from 'hooks/useFieldState'
function FormField({
  label,
  required,
  tooltip,
  type,
  defaultErrorState,
  ...rest
}) {
  const validateString = (value) => {
    return true
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    defaultErrorState,
    validatorFunction: validateString,
  })
  function resizeTextarea(textarea) {
    textarea.style.height = 'auto' // Reset height on edit
    textarea.style.height = textarea.scrollHeight + 'px' // Set new height
  }
  const handleBlur = (e) => {
    handleOnblur(e)
    e.target.style.height = 'auto'
  }
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="100%"
    >
      <SoftBox ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
          {required ? <span style={{ color: 'red' }}> *</span> : null}
          {tooltip?.title ? (
            <Tooltip
              TransitionComponent={Fade}
              title={tooltip.title}
              placement="top"
              color="info"
              enterTouchDelay={0}
              leaveTouchDelay={3000}
              {...tooltip.overrides}
            >
              <IconButton size="small" color="dark">
                <HelpIcon sx={{ marginTop: '-6px' }} />
              </IconButton>
            </Tooltip>
          ) : null}
        </SoftTypography>
      </SoftBox>
      <SoftInput
        multiline
        rows={8}
        error={isError}
        success={isSuccess}
        autoComplete="off"
        data-1p-ignore
        onBlur={(e) => handleBlur(e)}
        required={required}
        type={type}
        onInput={(e) => resizeTextarea(e.target)}
        {...rest}
      />
    </SoftBox>
  )
}

// Setting default values for the props of FormField
FormField.defaultProps = {
  label: ' ',
}

// Typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.shape({ title: PropTypes.string.isRequired }),
}

export default FormField
